type MenuItemMenu = {
  label: string
  columns?: number
  description?: string
  isDense?: boolean
  submenuItems: MenuItemData[]
  sendEvent?: () => void
}

export type MenuItemLink = {
  fullWidth?: boolean
  label: string
  description?: string
  isExternal?: boolean
  href: string
  sendEvent?: () => void
}

export type MenuItemData = MenuItemMenu | MenuItemLink

export const isMenuItemLink = (menuItem: MenuItemData): menuItem is MenuItemLink => {
  return 'href' in menuItem
}
